import * as c from "@yahshi/contracts";
import { createAdminRequest, type AdminHttpOptions } from "../../../lib/adminHttp";

export interface PointApi {
  list(query?: Partial<c.AdminPointAccountListQuery>): Promise<c.AdminPointAccountListResult>;
  get(appId: string, userId: string): Promise<c.AdminPointAccountDetail>;
  adjust(input: c.AdminAdjustPointsInput): Promise<c.AdminPointAccountDetail>;
}

const qs = (value: object) => new URLSearchParams(Object.entries(value).map(([key, item]) => [key, String(item)])).toString();

export function createHttpPointApi(options: AdminHttpOptions): PointApi {
  const request = createAdminRequest(options);
  return {
    list: (query = {}) => request(`/admin/points?${qs(c.adminPointAccountListQuerySchema.parse(query))}`, c.adminPointAccountListResultSchema),
    get: (appId, userId) => request(`/admin/points/${encodeURIComponent(appId)}/${encodeURIComponent(userId)}`, c.adminPointAccountDetailSchema),
    adjust: (input) => request("/admin/points/adjust", c.adminPointAccountDetailSchema, {
      method: "POST",
      body: JSON.stringify(c.adminAdjustPointsInputSchema.parse(input)),
    }),
  };
}
